import { IconText, LoadingSpinner, PrimaryButton } from "@sourceful/shared-components";
import { IconName } from "@sourceful/shared-types/src";
import { forwardRef } from "react";

interface LoadingButtonProps {
  handleClick?: () => void;
  isLoading: boolean;
  hasLoaded?: boolean;
  disabled?: boolean;
  defaultLabel: string;
  loadingMessage?: string;
  hasLoadedMessage?: string;
  borderRadius?: "round" | "square";
  compact?: boolean;
  className?: string;
  "data-cy"?: string;
  id?: string;
  type?: "button" | "submit";
  appearance?: "light" | "lightest" | "danger" | "warning";
  fullWidth?: boolean;
  primaryIcon?: IconName;
  secondaryIcon?: IconName;
}

const PrimaryLoadingButton = forwardRef<HTMLButtonElement, LoadingButtonProps>(
  (
    {
      handleClick,
      isLoading,
      disabled = false,
      loadingMessage = "Loading",
      defaultLabel,
      borderRadius,
      compact,
      hasLoadedMessage,
      hasLoaded,
      className,
      "data-cy": dataCy,
      type,
      appearance,
      id,
      fullWidth,
      primaryIcon,
      secondaryIcon,
    },
    ref
  ) => {
    const text =
      hasLoaded && hasLoadedMessage ? hasLoadedMessage : isLoading ? loadingMessage : defaultLabel;
    return (
      <PrimaryButton
        type={type || "button"}
        className={className}
        ref={ref}
        disabled={disabled}
        onClick={handleClick}
        borderRadius={borderRadius}
        compact={compact}
        data-cy={dataCy}
        css={
          fullWidth
            ? {
                width: "100%",
                display: "grid",
                gridTemplateColumns: isLoading ? "max-content 1fr" : "1fr",
                gridGap: "10px",
              }
            : {
                display: "grid",
                gridTemplateColumns: isLoading ? "max-content 1fr" : "1fr",
                gridGap: "10px",
              }
        }
        appearance={appearance}
        id={id}
      >
        {!hasLoaded && isLoading && <LoadingSpinner />}
        <IconText text={text} primaryIcon={primaryIcon} secondaryIcon={secondaryIcon} />
      </PrimaryButton>
    );
  }
);

export default PrimaryLoadingButton;
